<template>
  <div class="wptv-toolbar left-padding">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'WptvToolbar'
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '../../../scss/abstracts/abstracts';

.wptv-toolbar {
  display: flex;
  font-weight: bold;
  font-size: 1.714rem;
  @include mediaQueries('font-size', (medium: 2.429rem));
  align-items: center;
}
</style>
